import React, { useEffect } from 'react';

import classes from './NgzCustomerPaymentTab.module.scss';
import { angularizeWithProviders } from '../../../../shared/providers';
import { CurrentPlanWidget } from './CurrentPlanWidget/CurrentPlanWidget';
import { currentSubscriptionPlanStore } from '../../../stores/currentSubscriptionPlanStore';
import { BillingTypeFlags } from '../../../../shared/constants/user-info/billingType';
import { PaymentDetailsWidget } from './PaymentDetailsWidget/PaymentDetailsWidget';

type NgzCustomerPaymentTabProps = {
  customerId: number;
  entityId: number;
  billingType: BillingTypeFlags;
};

const NgzCustomerPaymentTab = ({
  customerId,
  entityId,
  billingType,
}: NgzCustomerPaymentTabProps) => {
  const { getPaymentDetails, setDefaultValues } = currentSubscriptionPlanStore;

  useEffect(() => {
    getPaymentDetails(customerId);

    return () => {
      setDefaultValues();
    };
  }, []);

  return (
    <div className={classes.row}>
      <CurrentPlanWidget customerId={customerId} entityBillingType={billingType} />
      <PaymentDetailsWidget customerId={customerId} entityId={entityId} />
    </div>
  );
};

angularizeWithProviders(NgzCustomerPaymentTab, 'ngzCustomerPaymentTab', {
  customerId: '<',
  entityId: '<',
  billingType: '<',
});

export { NgzCustomerPaymentTab };
